import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SettingsTabs from "../AllTabs/SettingsTabs";
import Header from "../../Common/Layout/Header";

const MarkupSetting = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [markup, setMarkup] = useState({});
  const [editedMarkup, setEditedMarkup] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);

  // Helper function to display data (show 0 for null/undefined)
  const displayValue = (value) => {
    return value !== undefined && value !== null ? value : "0";
  };

  const GetMarkupData = () => {
    setPageLoading(true);
    apiService
      .getAll(`${config.GETMARKUPBYCOMPANYID}/${user.cid}`)
      .then((res) => {
        if (res) {
          console.log(res)
          setMarkup(res[0]);
        }
        setPageLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching markup data", err);
        setPageLoading(false);
      });
  };

  useEffect(() => {
    if (user && !loading) {
      GetMarkupData();
    }
  }, [user, loading]);

  const startEdit = () => {
    setEditedMarkup({ ...markup });
    setEditMode(true);
  };

  const cancelEdit = () => {
    setEditMode(false);
    setEditedMarkup({});
  };

  const handleUpdate = async () => {
    setBtnLoading(true);
    try {
      await apiService.update(config.UPDATEMARKUP, editedMarkup);
      setEditMode(false);
      GetMarkupData(); 
    } catch (err) {
      console.error("Update failed", err);
      toast.error("Failed to update markup");
    } finally {
      setBtnLoading(false);
    }
  };

   if (loading || !user) {
    return <div className="page-content">Loading...</div>;
  }
  if (!user) navigate("/");

  return (
       <div id="layout-wrapper">
          <Header User={user} />
          <div className="main-content">
            <div className="page-content">
              <div className="container-fluid"></div>
          <div className="container-fluid">
            <div className="card mb-3">
                          <div className="p-2">
                            <SettingsTabs pageName="MARKUPSETTING" />
                          </div>
                        </div>
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2 align-items-center">
                  <h4 className="card-title mb-4 mt-3 ps-2">Manage Company Markups</h4>
                  {/* Domestic Flight Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">Domestic Flight Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.domesticFlightMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, domesticFlightMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.domesticFlightMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* International Flight Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">International Flight Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.internationalFlightMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, internationalFlightMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.internationalFlightMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Domestic Hotel Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">Domestic Hotel Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.domesticHotelMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, domesticHotelMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.domesticHotelMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* International Hotel Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">International Hotel Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.internationalHotelMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, internationalHotelMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.internationalHotelMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Sightseeing Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">Sightseeing Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.sightseeingMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, sightseeingMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.sightseeingMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Bus Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">Bus Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.busMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, busMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.busMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Visa Markup */}
                  <div className="row mb-3">
                    <label className="col-sm-2 col-form-label">Visa Markup:</label>
                    <div className="col-sm-4">
                      {editMode ? (
                        <div className="input-group">
                          <span className="input-group-text">{user.currency}</span>
                          <input
                            type="number"
                            className="form-control"
                            value={editedMarkup.visaMarkup || 0}
                            onChange={(e) => setEditedMarkup({ ...editedMarkup, visaMarkup: parseFloat(e.target.value) })}
                          />
                        </div>
                      ) : (
                        <span className="form-control-plaintext fw-bold">
                          {user.currency} {displayValue(markup.visaMarkup)}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="d-flex justify-content-center mt-4 mb-3">
                    {!editMode ? (
                      <button className="btn btn-primary px-4" onClick={startEdit}>
                        <i className="ri-pencil-line me-2"></i>Edit Markups
                      </button>
                    ) : (
                      <>
                        <button
                          className="btn btn-success me-2 px-4"
                          onClick={handleUpdate}
                          disabled={btnLoading}
                        >
                          {btnLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Saving...
                            </>
                          ) : (
                            <>
                              <i className="fas fa-save me-2"></i>Save Changes
                            </>
                          )}
                        </button>
                        <button className="btn btn-danger px-4" onClick={cancelEdit}>
                          <i className="fas fa-times me-2"></i>Cancel
                        </button>
                      </>
                    )}
                  </div>

                </div>
              </div>
            </div>
          </div>
          </div>
          </div>
          </div>
  );
};

export default MarkupSetting;